<template>
    <div class="container">
        <b-modal :model-value="modCreaReporte" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5> 
                    </b-col>
                    <b-col cols="5" class="text-left">
                        <input type="number" v-model="codigo" class="form-control" />
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.nombre}}</h5> 
                    </b-col>
                    <b-col cols="5" class="text-left">
                        <input type="text" v-model="nombre" class="form-control" />
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.principal}}</h5> 
                    </b-col>
                    <b-col cols="5" class="text-left">
                        <select v-model="principal" class="form-control">
                            <option value="">{{ labels.select }}</option> 
                            <option value="1">{{ labels.yes }}</option> 
                            <option value="0">{{ labels.not }}</option> 
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.libro_notas}}</h5> 
                    </b-col>
                    <b-col cols="5" class="text-left">
                        <input type="text" v-model="libro_notas" class="form-control" />
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="guardaReporte">{{ labels.save }}</b-button> 
                    <b-button class="md-accent" @click="closeModal">{{ labels.close }}</b-button> 
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import TipoReporte from '../../../services/TipoReporte' 
export default {
    name:'CreaReporte',
    props:['modCreaReporte'],
    data:() => ({
        codigo : '',
        nombre : '',
        principal : '',
        libro_notas: '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear reporte',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código:',
                    nombre : 'Nombre:',
                    libro_notas : 'Libro Notas:',
                    principal : 'Principal:',
                    select : 'Seleccione...', 
                    yes : 'SI',
                    not : 'NO'
                }
            }else{
                return {
                    title : 'Create report',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code:',
                    nombre : 'Name:',
                    libro_notas: 'Notes',
                    principal : 'Principal:',
                    select : 'Select...', 
                    yes : 'YES',
                    not : 'NO'
                }
            }
        }
    },
    methods:{
        guardaReporte(){
            if(this.codigo == '' || this.nombre == '' || this.principal == ''){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar');
                
            }else{                
                let dataReport = {
                    'codigo' : this.codigo,
                    'nombre' : this.nombre,
                    'principal' : this.principal,
                    'idUser' : this.$store.state.userId
                }
  TipoReporte.createReporte(dataReport) 
  .then((res) => { 
			this.$toast.success(res.data.message)
			this.$emit('refrescaTbl')
			this.clearCampos()
		})
  .catch((err) => { 
   console.log(err); 
			this.$toast.error(err.response.data.message)
		})
            }
        },
        closeModal(){
            this.$emit('closeModal',false)
        },
        clearCampos(){
            this.codigo = ""
            this.nombre = ""
            this.principal = ""
        }
    }
}
</script>
<style>
</style>
